export const KIOSK_GATE_SELECTOR = 'KIOSK_GATE_SELECTOR';

export const DASHBOARD_SOURCE = 'kiosks-dashboard';

export const DETAILS_SOURCE = 'details-page';

export const SELECT_SOURCE = 'kiosks-select';

export const KioskType = {
  PARTTEAM: 'PARTTEAM',
  SHAREBOX: 'SHAREBOX',
} as const;

export type KioskType = (typeof KioskType)[keyof typeof KioskType];

export const KioskPaymentType = {
  ADYEN: 'ADYEN',
  BEZAHL: 'BEZAHL',
  YPAY: 'YPAY',
} as const;

export type KioskPaymentType = (typeof KioskPaymentType)[keyof typeof KioskPaymentType];

export const KioskModel = {
  INDOOR: 'INDOOR',
  OUTDOOR: 'OUTDOOR',
  I32: 'I32',
  M28: 'M28',
  S32: 'S32',
  S32_PLUS: 'S32_PLUS',
  W64: 'W64',
} as const;

export type KioskModel = (typeof KioskModel)[keyof typeof KioskModel];

export const KioskStatus = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  INACTIVE: 'INACTIVE',
} as const;

export type KioskStatus = (typeof KioskStatus)[keyof typeof KioskStatus];

export const KioskConnectionStatus = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
} as const;

export type KioskConnectionStatus = (typeof KioskConnectionStatus)[keyof typeof KioskConnectionStatus];

export const BrandTheme = {
  DEFAULT: 'DEFAULT',
  PORSCHE: 'PORSCHE',
} as const;

export type BrandTheme = (typeof BrandTheme)[keyof typeof BrandTheme];

/** The models each kiosk type comes in, mirroring the backend `Kiosk.Type` enum. */
export const KIOSK_MODELS_BY_TYPE: Record<KioskType, ReadonlyArray<KioskModel>> = {
  [KioskType.PARTTEAM]: [KioskModel.INDOOR, KioskModel.OUTDOOR],
  [KioskType.SHAREBOX]: [KioskModel.I32, KioskModel.M28, KioskModel.S32, KioskModel.S32_PLUS, KioskModel.W64],
};

/** The PARTTEAM models, the only ones the form shows under a translated label. */
export const TRANSLATED_KIOSK_MODELS = [KioskModel.INDOOR, KioskModel.OUTDOOR] as const;

const MODELS_WITHOUT_SCREENSAVER: Array<KioskModel> = [KioskModel.M28, KioskModel.S32];

/**
 * Whether a kiosk model can display a screensaver.
 * @param model the kiosk model, as returned by the models reference endpoint
 */
export const modelSupportsScreensaver = (model: KioskModel) => !MODELS_WITHOUT_SCREENSAVER.includes(model);
